import { navLinks } from "@/mocks/content";

export default function Footer() {
  return (
    <footer className="bg-accent-50 text-foreground-700">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.6fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-bubble-chart-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">51黑瓜</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              大赏、精选、盘点、榜单一网打尽。实时追踪热门瓜料与圈内动态，做你身边最可靠的吃瓜情报站。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="#top"
                aria-label="微信公众号"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition hover:bg-primary-100 hover:text-primary-700"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#top"
                aria-label="新浪微博"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition hover:bg-primary-100 hover:text-primary-700"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#top"
                aria-label="抖音"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition hover:bg-primary-100 hover:text-primary-700"
              >
                <i className="ri-music-2-line"></i>
              </a>
              <a
                href="#top"
                aria-label="今日头条"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition hover:bg-primary-100 hover:text-primary-700"
              >
                <i className="ri-newspaper-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950">快捷导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 transition hover:text-primary-700">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600"></i>
                <a href="mailto:hello@51heigua.com" className="hover:text-primary-700">hello@51heigua.com</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-600"></i>
                每天 9:00 - 22:00 在线
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-copyright-line text-primary-600"></i>
                内容聚合 · 尊重事实
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-background-200/60">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p className="whitespace-nowrap">© 2026 51黑瓜 · 保留所有权利</p>
          <p className="text-center text-foreground-500">本站内容仅为娱乐信息聚合与观点分享，不代表任何权威立场。</p>
        </div>
      </div>
    </footer>
  );
}